import { render, staticRenderFns } from "./HeaderDigitalStore.vue?vue&type=template&id=04fab76a&"
import script from "./HeaderDigitalStore.vue?vue&type=script&lang=js&"
export * from "./HeaderDigitalStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports